import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckout } from '../hooks/useMetaPixel';
type CTAButtonProps = {
  label: string;
  variant?: 'gold' | 'navy';
  subline?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  variant = 'navy',
  subline,
  id,
  className = ''
}: CTAButtonProps) {
  const base = variant === 'gold' ? 'bg-gold text-navy-deep hover:bg-gold-light shadow-[0_10px_30px_-10px_rgba(200,162,74,0.8)]' : 'bg-navy text-white hover:bg-navy-soft shadow-[0_10px_30px_-12px_rgba(10,31,68,0.75)]';
  return <div id={id} className={`w-full ${className}`} data-id="element-27" data-mp="33ommtd5d488h">
      <a href={CHECKOUT_URL} onClick={trackCheckout} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-all duration-200 active:scale-[0.98] sm:px-8 sm:text-lg ${base}`} data-id="element-28" data-mp="2yqcsf4rgpbnx">
        <span className="max-w-[22rem] sm:max-w-none" data-id="element-29" data-mp="199y7eb42dt25">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-30" data-mp="1da8a9ewk83cs" />
      </a>
      {subline ? <p className="mt-3 text-center text-[13px] font-medium text-navy/60" data-id="element-31" data-mp="1i8t9bb02sgzn">
          {subline}
        </p> : null}
    </div>;
}